import React, { useEffect, useState } from 'react';
import { Button, Modal } from "antd";
import { ListComponent } from 'containers/backend/common/component/Index';
import * as Func from '../../../../../helpers/functions';
import { DETAIL_ACTIONS } from 'constants/Define';

const modelItem = ["airportCode", "airportName", "cityCode", "cityName"];

const ToAirportListModal = ({t, action, toAirportList, selectedAirportCodes, updateToAirportList }) => {
    const [visible, setVisible] = useState(false);
    const [titleItemTable] = useState(Func.getTitleTable(modelItem, [], []))
    const [checkedItem, setCheckedItem] = useState(selectedAirportCodes);

    useEffect(() => {
        if(visible){
            setCheckedItem(selectedAirportCodes);
        }
    }, [visible])

    useEffect(() => {
        setCheckedItem(selectedAirportCodes);
    }, [selectedAirportCodes])

    const showModal = () => {
        setVisible(true)
    };

    const handleOk = e => {
        updateToAirportList(checkedItem);
        setVisible(false)
    }

    const handleCancel = e => {
        setVisible(false)
    };


    const rowSelection = {
        selectedRowKeys: checkedItem,
        onChange: (selectedRowKeys) => setCheckedItem(selectedRowKeys),
        getCheckboxProps: (record) => ({
            name: record.name,
        })
    }

    return (
        <div>
            <Button
                className='p-0'
                type="link"
                disabled={action === DETAIL_ACTIONS.TRANSLATE}
                onClick={showModal}>
                {t(`item.airport.toAirportList`)} {`(${selectedAirportCodes?.length || 0})`}
            </Button>
            <Modal
                title={t(`item.airport.selectToAirport`)}
                visible={visible}
                onOk={handleOk}
                onCancel={handleCancel}
                width={900}
                wrapClassName='to-airport-list-modal'
                destroyOnClose={true}
                okText={t(`action.confirm`)}
                cancelText={t(`action.cancel`)}
            >
                <ListComponent
                    classParent="m-0 p-0 col-md-12"
                    marginTop={'0'} marginBottom={'0'}
                    rowKey={record => record.airportCode}
                    dataSource={Func.getDataSource(toAirportList, modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: {},
                        itemName: 'airport'
                    })}
                    componentTableList={{}}
                    hideSettings={true}
                    rowSelection={{type: 'checkbox',...rowSelection}}
                />
            </Modal>
        </div>
    )
}

export default ToAirportListModal;